<script>
	var userContext = require('core/userContext');
	var config = require('core/config');
	var model = require('model/model');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const WORKSPACE_TOOL_CLICK = analyticsUtilities.events.WORKSPACE_TOOL_CLICK;
	const i18nMixin = require('i18n/i18nMixin.js');

	module.exports = {
		props: [
			'paragraphsNumbered',
			'workspace',
			'product',
			'submit-assignment',
			'route-context',
			'sub-article',
			'show-annotations',
			'showVocabularyActivities'
		],

		mixins: [i18nMixin],
		components: {
			'audio-player': require('components/audio-player.vue').default,
			'product-news-header': require('components/product-news-header.vue').default,
			'thumbtack-icon': require('components/svg/thumbtack-icon.vue').default,
			'content-footer': require('components/routes/student-workspace/content-footer.vue').default,
			'apple-icon': require('components/svg/apple-icon.vue').default,
			'lightning-icon': require('components/svg/lightning-icon.vue').default,
			'vocab-popup-content-wrapper': require('components/vocab-popup-content-wrapper.vue').default,
			'vocab-rate-words': require('components/vocab-rate-words.vue').default
		},

		modelData: ['activeProduct', 'disableCopyPaste', 'splitScreen', 'offlineMode'],

		data: function () {
			return {
				studentName: '',
				ellFlag: null,
				highlights: [],
				audioPinned: false,
				isTeacher: !userContext.isStudent()
			};
		},
		mounted() {
			this.studentName = userContext.getFullName();
			this.ellFlag = userContext.getELLFlag();
		},
		computed: {
			parentPid: function () {
				let isAAD = this.activeProduct.productType === 'AAD';
				let parentPid = undefined;
				// is AAD or PT
				if (isAAD || this.subArticle) {
					parentPid = this.activeProduct.uuid;
				}
				return parentPid;
			},
			selectedProduct: function () {
				return this.subArticle || this.product;
			},
			showAudioPlayer: function () {
				let ellEnabled = this.workspace.opts.ell && this.ellFlag && this.ellFlag !== '';
				let hasAudio = this.mp3;
				let showAudio = false;
				if (hasAudio && (ellEnabled || this.workspace.opts.au)) {
					showAudio = true;
				}

				return showAudio;
			},
			mp3() {
				const product = this.selectedProduct;

				if (product) {
					const audio = product.audio;
					const isDecodable = !!product.decodableTeacherEdition;

					if (audio && !isDecodable) {
						const endpoint = (config.resources.media.cdn || config.resources.media.origin) + '/data/audio/';
						return endpoint + audio + '.mp3';
					}
				}

				return '';
			},
			isNewsArticle: function () {
				let article = this.selectedProduct;
				if (article && article.subType === 102) {
					return true;
				}
				return false;
			},
			authors() {
				let selectedProduct = this.selectedProduct;
				let authorList = null;

				if (selectedProduct && selectedProduct.authors) {
					authorList = selectedProduct.authors.join(', ');
				}

				return authorList;
			},
			showChallengeBadge() {
				let workspace = this.workspace;
				let selectedProduct = this.selectedProduct;
				let activeProduct = this.activeProduct;
				let show = false;

				if (workspace && workspace.opts.challenge && selectedProduct && activeProduct) {
					let uuid = selectedProduct.uuid;
					if (activeProduct.supplemental_texts && activeProduct.supplemental_texts.challenge && activeProduct.supplemental_texts.challenge[uuid]) {
						show = true;
					}
				}

				return show;
			},
			showSupportBadge() {
				let workspace = this.workspace;
				let selectedProduct = this.selectedProduct;
				let activeProduct = this.activeProduct;
				let show = false;

				if (workspace && workspace.opts.support && selectedProduct && activeProduct) {
					let uuid = selectedProduct.uuid;
					if (activeProduct.supplemental_texts && activeProduct.supplemental_texts.support && activeProduct.supplemental_texts.support[uuid]) {
						show = true;
					}
				}

				return show;
			},
			isSubmitted() {
				let workspace = this.workspace;
				let pid = this.routeContext.params.pid;
				let submitted = false;
				if (workspace) {
					submitted = workspace.s === 's';
					if (!submitted && pid && workspace.scoreState && workspace.scoreState.a && workspace.scoreState.a[pid]) {
						submitted = workspace.scoreState.a[pid].s === 's';
					}
				}
				return submitted;
			}
		},
		methods: {
			navigateToBOK: function () {
				model.set({
					wsTab: 'book-of-knowledge'
				});
			},
			checkCutCopy(event) {
				if (this.disableCopyPaste) {
					event.preventDefault();
				}
			},
			toggleAudioPin() {
				let tab = model.get('wsTab');
				let pid = this.selectedProduct.id || this.selectedProduct.uuid;
				let aid = this.routeContext.params.aid;
				let ss = model.get('splitScreen') || undefined;

				this.audioPinned = !this.audioPinned;

				fireEvent(WORKSPACE_TOOL_CLICK, {
					action_type: 'pin_audio',
					state: this.audioPinned,
					tab,
					pid,
					aid,
					ss
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';
	@import 'mixins/media';

	.main-content.text-tab {
		.title-container {
			display: flex;
			align-items: center;

			.title-text-container {
				flex: 1;

				h1.content-title {
					margin: 0rem;
					font-family: var(--custom-font-family, $helvetica);
				}
			}

			.supplemental-badge {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.5rem;
				font-weight: 500;

				.icon-container {
					width: 54px;
					height: 54px;
					padding: 0.5rem;
					border-style: solid;
					border-width: 2px;
					border-radius: 2rem;
				}

				&.challenge-badge {
					border-color: $c-blue;
					color: $c-blue;

					svg {
						stroke: $c-blue;
					}
				}

				&.support-badge {
					border-color: $c-blue;
					color: $c-blue;

					svg {
						width: 26px;
						height: auto;
						stroke: $c-blue;
					}
				}
			}
		}

		.decodable-content {
			article {
				font-size: 1.75em;
			}
		}
	}

	.article-audio {
		position: sticky;
		top: 2.5rem;
		z-index: 10;
		display: flex;
		align-items: center;

		&.pinned {
			position: static;
		}

		@include media(med) {
			top: -1.5rem;
		}

		.audio-player {
			flex: 1;
			transition: all 0.5s ease-in;
		}

		button.button.audio-pin-button {
			border-radius: 4rem;
			margin: 1rem;
			padding: 0.25rem 0.75rem;

			svg {
				height: 1rem;
				width: 1rem;
			}
		}

		&.pinned button.button.audio-pin-button svg {
			transform: rotate(-45deg);
		}
	}
</style>
<template>
	<div
		v-if="activeProduct"
		class="main-content wrapper text-tab"
		@copy="checkCutCopy"
		@cut="checkCutCopy"
		@dragstart="checkCutCopy">
		<div
			v-if="!isNewsArticle"
			class="title-container">
			<div class="title-text-container">
				<h1 class="content-title">{{ selectedProduct.title || product.title }}</h1>
				<div
					v-if="authors"
					class="font-small text-muted">
					by {{ authors }}
				</div>
			</div>
			<div
				v-if="showChallengeBadge || showSupportBadge"
				class="supplemental-badge text-centered"
				:class="{
					'challenge-badge': showChallengeBadge,
					'support-badge': showSupportBadge
				}">
				<div class="icon-container">
					<lightning-icon v-if="showChallengeBadge"></lightning-icon>
					<apple-icon v-if="showSupportBadge"></apple-icon>
				</div>
				<div class="badge-text">
					<template v-if="showChallengeBadge">Challenge</template>
					<template v-if="showSupportBadge">Boost</template>
					<br />
					Article
				</div>
			</div>
		</div>
		<div
			class="main-content-article rte"
			v-bind:class="{ 'numbered-paragraphs': paragraphsNumbered }">
			<header
				v-show="offlineMode === false"
				class="article-audio"
				:class="{
					pinned: audioPinned
				}">
				<audio-player
					v-if="offlineMode === false && showAudioPlayer"
					:event-data="{
						parentPid: parentPid,
						pid: selectedProduct.uuid,
						aid: routeContext.params.aid,
						tag: 'article'
					}"
					:src="mp3"
					:show-speed-selector="true">
				</audio-player>
				<button
					v-if="showAudioPlayer"
					class="button -outline audio-pin-button"
					@click="toggleAudioPin"
					v-tooltip="'Pin to top'"
					:class="{
						'-active': audioPinned
					}">
					<thumbtack-icon></thumbtack-icon>
				</button>
			</header>
			<product-news-header
				v-if="isNewsArticle"
				:banner="selectedProduct.banner"
				:title="selectedProduct.title"
				:sub-headline="selectedProduct.subHeadline"
				:byline="selectedProduct.byline"
				:news-date="selectedProduct.newsDate">
			</product-news-header>
			<div
				v-if="workspace.opts.h"
				v-html="workspace.text"></div>
			<template v-else>
				<vocab-popup-content-wrapper
					:event-data="{
						assignmentId: routeContext.params.aid,
						parentPid: parentPid,
						loc: 'workspace'
					}"
					:article="selectedProduct">
					<annotated-text
						v-if="offlineMode === false && showAnnotations"
						:class="{
							'decodable-content': selectedProduct.decodableTeacherEdition
						}"
						:content="selectedProduct.content"
						:assignment-id="routeContext.params.aid"
						:uuid="selectedProduct.uuid"
						:allow-edit="workspace.s !== 's'"
						:minimal="activeProduct.productType === 'AAD'"
						:persist="!isTeacher"
						:show-audio="showAudioPlayer"
						:language="selectedProduct.language">
					</annotated-text>
					<div
						v-else
						v-html="selectedProduct.content"></div>
				</vocab-popup-content-wrapper>
			</template>
			<div class="text-left">
				<button
					v-if="
						activeProduct &&
						activeProduct.productType === 'A' &&
						workspace &&
						workspace.s === 'a' &&
						workspace.opts &&
						workspace.opts.qs &&
						workspace.opts.qs.length == 0 &&
						!showVocabularyActivities
					"
					type="submit"
					class="button -large -loading-to-right"
					v-on:click="submitAssignment">
					Submit
				</button>
				<button
					v-if="routeContext.params.pid && workspace.opts.qs.length == 0 && (!workspace.opts.bok || selectedProduct.decodableTeacherEdition)"
					type="submit"
					class="button -large -loading-to-right text-tab-submit"
					v-on:click="submitAssignment">
					I'm Done Reading
				</button>
				<button
					@click.prevent="navigateToBOK()"
					class="button -large"
					v-if="!isSubmitted && routeContext.params.pid && workspace.opts.bok && !selectedProduct.decodableTeacherEdition && !splitScreen">
					Book of Knowledge &rarr;
				</button>
				<button
					class="button next-workspace-tab"
					v-if="activeProduct && activeProduct.productType === 'P' && activeProduct.subType !== 8000 && workspace && workspace.s === 'a'"
					@click="$emit('next-workspace-tab')">
					<i
						class="fa-solid fa-arrow-right fa-lg"
						aria-hidden="true"></i>
				</button>
			</div>
			<content-footer :selected-product="selectedProduct"> </content-footer>
		</div>
	</div>
</template>
